import React from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react'
import Icon from 'components/common/Icon'

// maps "type" of tool note to an icon to use
const icons = {
  info: 'fa-info-circle',
  warning: 'fa-exclamation-triangle'
}

const ToolNote = ({ children, type }) => (
  <div className={classnames('tool-note', type)}>
    <Icon id={icons[type]} extraClasses={['icon-lg']} />
    <span>{children}</span>
  </div>
)

export default observer(ToolNote)
